const getPlanocontaFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'conta', label: 'Conta' },
  {
    name: 'plano',
    label: 'Plano',
    type: 'select',
    options: drops?.Plano,
    multiple: true,
  },
  {
    name: 'inivalid.i',
    column: 'inivalid',
    label: 'Início da Validade Inicial',
    type: 'date',
  },
  {
    name: 'inivalid.f',
    column: 'inivalid',
    label: 'Início da Validade Final',
    type: 'date',
  },
  {
    name: 'fimvalid.i',
    column: 'fimvalid',
    label: 'Fim da Validade Inicial',
    type: 'date',
  },
  {
    name: 'fimvalid.f',
    column: 'fimvalid',
    label: 'Fim da Validade Final',
    type: 'date',
  },
];

export default getPlanocontaFilterFields;
